import { render, staticRenderFns } from "./payment-methods.vue?vue&type=template&id=33bb76b6"
import script from "./payment-methods.vue?vue&type=script&lang=js"
export * from "./payment-methods.vue?vue&type=script&lang=js"
import style0 from "./payment-methods.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports